import noUiSlider from 'nouislider'

document.addEventListener("DOMContentLoaded", function(){
    setTimeout(function(){
        var sliders = document.getElementsByClassName('quotaSlider');

        if (sliders.length > 0) {
            for (var key = 0; key < sliders.length; key++) {
                var slider = sliders.item(key);
                var max = parseInt(slider.getAttribute("data-max"));
                var step = parseInt(slider.getAttribute("data-step"));
                noUiSlider.create(slider, {
                    start: [0, 0],
                    connect: true,
                    step: step,
                    range: {
                        'min': 0,
                        'max': max
                    },
                });

                // Disable first handle that it's used only for color
                var origins = slider.getElementsByClassName('noUi-origin');
                origins[0].setAttribute('disabled', true);
        
                var quotaValue = slider.closest(".slidecontainer").querySelector(".slider-value");
                slider.noUiSlider.on('update', function (values, handle) {
                    if (handle == 1) {
                        quotaValue.value = Number(values[handle]).toFixed(0);
                        quotaValue.dispatchEvent(new Event('change'));
                    }
                });
        
                slider.noUiSlider.setHandle(1, 0, true, true);

                quotaValue.addEventListener('change', function(){
                    if (Number(slider.noUiSlider.get()[1]).toFixed(0) != quotaValue.value) {
                        slider.noUiSlider.setHandle(1, quotaValue.value, true, true);
                    }
                })
            }
        }
    }, 500);
});